const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  select: {
    width: '100%',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    '& .MuiTypography-root': {
      flex: 1,
    },
    [`@media (max-width: 768px)`]: {
      '& .MuiTypography-root': {
        fontSize: '14px',
      },
      '& .iconify': {
        fontSize: '20px',
      },
      padding: '8px',
    },
    [`@media (max-width: 480px)`]: {
      '& .MuiTypography-root': {
        fontSize: '13px',
      },
      '& .iconify': {
        fontSize: '18px',
      },
      padding: '6px',
    },
  },
  twoTextfield: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
  },
  mobileSelect: {
    marginTop: '20px',
    width: '100%',

    [`@media (max-width: 1440px)`]: {
      display: 'block',
    },
    [`@media (max-width: 768px)`]: {
      marginBottom: '16px',
      '& .MuiInputLabel-root': {
        fontSize: '14px',
      },
      '& .MuiSelect-root': {
        fontSize: '14px',
        padding: '10px 14px',
      },
    },
    [`@media (max-width: 480px)`]: {
      marginBottom: '12px',
      '& .MuiInputLabel-root': {
        fontSize: '13px',
      },
      '& .MuiSelect-root': {
        fontSize: '13px',
        padding: '8px 12px',
      },
    },
  },
})

export default styles
